<div class="col-12 sign-up-box">
  <div *ngIf="!profileVerification" class="col-6 mt-20 logo margin-centered">
    <img
      alt="{{ 'lbl_img_alt_logo' | translate }}"
      class="full-width"
      src="../../../../../assets/images/logo/pitch59-logo-gray.svg"
    />
  </div>
  <div class="col-12 heading text-center" translate>label_reset_password</div>
  <form (ngSubmit)="resetPassword()" [formGroup]="resetPasswordForm">
    <div class="col-12 text-center mail-text">
      <div class="para">We have sent you a 4 digit code to</div>
      <div class="emailaddress">{{ contactNumber }}</div>
    </div>

    <div class="form-row col-12">
      <div class="form-row-input">
        <span class="p-float-label">
          <input
            id="smsOtpCode"
            appNoLeadingSpace
            autocomplete="tel"
            class="input-primary bg-transparent shadow-none full-width"
            formControlName="smsOtpCode"
            inputmode="tel"
            onfocus="this.removeAttribute('readonly')"
            pInputText
            pKeyFilter="int"
            readonly
            size="30"
            type="tel"
          />
          <label for="smsOtpCode" translate>label_enter_digit_code</label>
        </span>
        <div
          *ngIf="
            resetPasswordForm.controls.smsOtpCode.invalid &&
            (resetPasswordForm.controls.smsOtpCode.dirty ||
              resetPasswordForm.controls.smsOtpCode.touched)
          "
          class="form-errors"
        >
          <div
            *ngIf="resetPasswordForm.controls.smsOtpCode.errors.required"
            translate
          >
            err_required_digitCode
          </div>
          <div
            *ngIf="resetPasswordForm.controls.smsOtpCode.errors.pattern"
            translate
          >
            err_invalid_digitCode
          </div>
        </div>
      </div>
    </div>

    <div class="form-row col-12">
      <div class="form-row-input">
        <span class="p-float-label">
          <input
            #newpasswordInput
            id="newpassword"
            (blur)="showPasswordRequirements = false"
            (focus)="showPasswordRequirements = true"
            appNoLeadingSpace
            autocomplete="off"
            class="input-primary bg-transparent shadow-none full-width"
            formControlName="newpassword"
            minlength="3"
            pInputText
            type="password"
          />
          <label for="newpassword" translate> label_new_password </label>
          <div
            (click)="toggleNewPassword()"
            *ngIf="isPasswordVisible('newpassword')"
            class="sprite eye"
          ></div>
          <div
            (click)="toggleNewPassword()"
            *ngIf="!isPasswordVisible('newpassword')"
            class="sprite close-eye"
          ></div>
        </span>
        <div
          *ngIf="
            resetPasswordForm.controls.newpassword.invalid &&
            (resetPasswordForm.controls.newpassword.dirty ||
              resetPasswordForm.controls.newpassword.touched)
          "
          class="form-errors"
        >
          <div
            *ngIf="resetPasswordForm.controls.newpassword.errors.required"
            translate
          >
            err_required_password
          </div>

          <div *ngIf="showPasswordRequirements" class="password-validator">
            <label
              [ngClass]="
                resetPasswordForm.controls['newpassword'].hasError(
                  'required'
                ) ||
                resetPasswordForm.controls['newpassword'].hasError('minlength')
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <i
                [ngClass]="{
                  'pi-times-circle':
                    resetPasswordForm.controls['newpassword'].hasError(
                      'required'
                    ) ||
                    resetPasswordForm.controls['newpassword'].hasError(
                      'minlength'
                    ),
                  'pi-check-circle': !(
                    resetPasswordForm.controls['newpassword'].hasError(
                      'required'
                    ) ||
                    resetPasswordForm.controls['newpassword'].hasError(
                      'minlength'
                    )
                  )
                }"
                class="pi"
              >
              </i>
              8 characters
            </label>
            <label
              [ngClass]="
                resetPasswordForm.controls['newpassword'].hasError(
                  'required'
                ) ||
                resetPasswordForm.controls['newpassword'].hasError('hasNumber')
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <i
                [ngClass]="{
                  'pi-times-circle':
                    resetPasswordForm.controls['newpassword'].hasError(
                      'required'
                    ) ||
                    resetPasswordForm.controls['newpassword'].hasError(
                      'hasNumber'
                    ),
                  'pi-check-circle': !(
                    resetPasswordForm.controls['newpassword'].hasError(
                      'required'
                    ) ||
                    resetPasswordForm.controls['newpassword'].hasError(
                      'hasNumber'
                    )
                  )
                }"
                class="pi"
              >
              </i>
              1 number
            </label>
            <label
              [ngClass]="
                resetPasswordForm.controls['newpassword'].hasError(
                  'required'
                ) ||
                resetPasswordForm.controls['newpassword'].hasError(
                  'hasCapitalCase'
                )
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <i
                [ngClass]="{
                  'pi-times-circle':
                    resetPasswordForm.controls['newpassword'].hasError(
                      'required'
                    ) ||
                    resetPasswordForm.controls['newpassword'].hasError(
                      'hasCapitalCase'
                    ),
                  'pi-check-circle': !(
                    resetPasswordForm.controls['newpassword'].hasError(
                      'required'
                    ) ||
                    resetPasswordForm.controls['newpassword'].hasError(
                      'hasCapitalCase'
                    )
                  )
                }"
                class="pi"
              >
              </i>
              1 uppercase letter
            </label>
            <label
              [ngClass]="
                resetPasswordForm.controls['newpassword'].hasError(
                  'required'
                ) ||
                resetPasswordForm.controls['newpassword'].hasError(
                  'hasSmallCase'
                )
                  ? 'text-danger'
                  : 'text-success'
              "
            >
              <i
                [ngClass]="{
                  'pi-times-circle':
                    resetPasswordForm.controls['newpassword'].hasError(
                      'required'
                    ) ||
                    resetPasswordForm.controls['newpassword'].hasError(
                      'hasSmallCase'
                    ),
                  'pi-check-circle': !(
                    resetPasswordForm.controls['newpassword'].hasError(
                      'required'
                    ) ||
                    resetPasswordForm.controls['newpassword'].hasError(
                      'hasSmallCase'
                    )
                  )
                }"
                class="pi"
              >
              </i>
              1 lowercase letter
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="form-row col-12">
      <div class="form-row-input">
        <span class="p-float-label">
          <input
            #confirmpasswordInput
            id="confirmpassword"
            appNoLeadingSpace
            autocomplete="off"
            class="input-primary bg-transparent shadow-none full-width"
            formControlName="confirmpassword"
            minlength="3"
            pInputText
            type="password"
          />
          <label for="confirmpassword" translate>label_confirm_password</label>
          <div
            (click)="toggleConfirmPassword()"
            *ngIf="isPasswordVisible('confirmpassword')"
            class="sprite eye"
          ></div>
          <div
            (click)="toggleConfirmPassword()"
            *ngIf="!isPasswordVisible('confirmpassword')"
            class="sprite close-eye"
          ></div>
        </span>
        <div
          *ngIf="
            resetPasswordForm.controls.confirmpassword.invalid &&
            resetPasswordForm.controls.confirmpassword.touched
          "
          class="form-errors"
        >
          <div
            *ngIf="resetPasswordForm.controls.confirmpassword.errors.required"
            translate
          >
            err_required_confirmpassword
          </div>

          <div
            *ngIf="
              !resetPasswordForm.controls.confirmpassword.errors.required &&
              (resetPasswordForm.controls.confirmpassword.dirty ||
                resetPasswordForm.controls.confirmpassword.touched) &&
              resetPasswordForm.controls.confirmpassword.value !==
                resetPasswordForm.controls.newpassword.value
            "
            translate
          >
            err_confirm_password_not_match
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 form-errors">
      {{ errorMessage }}
    </div>
    <div class="col-12 text-center">
      <button
        [disabled]="loading || resetPasswordForm.invalid"
        class="button-simple lg-50 shock-pink text-center"
        translate
      >
        label_reset
      </button>
    </div>
    <div class="col-12 text-center">
      <span
        (click)="resendOTP()"
        [ngClass]="{
          'mock-link-disabled': isTimerRunning
        }"
        class="mock-link"
        translate
      >lbl_resend_otp</span
      >
      <span *ngIf="otpTimer !== '00'" class="otp-timer">
        (00:{{ otpTimer }})</span
      >
    </div>
  </form>
</div>
